/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  utFormDataOfInspection: {},
  utFormDownloadingLoading: false
};

export const utFormDataSlice = createSlice({
  name: 'utFormData',
  initialState,
  reducers: {
    setUTFormData: (state, action) => {
      state.utFormDataOfInspection = action.payload;
    },
    setUTFormLoading: (state, action) => {
      state.utFormDownloadingLoading = action.payload;
    },

    deleteInspectionCML: (state, action) => {
      const copyUTFormDataOfInspection = { ...state.utFormDataOfInspection };
      const { [action?.payload]: _Remove, ...newUTFormDataOfInspection } =
        copyUTFormDataOfInspection;
      state.utFormDataOfInspection = newUTFormDataOfInspection;
    }
  }
});

const utFormReducer = utFormDataSlice.reducer;

export const utFormActions = utFormDataSlice.actions;
export default utFormReducer;
